export enum ImageTypeEnum {
  JPG = 'JPG',
  PNG = 'PNG',
}
